import React from 'react'
import snakeImg from '../assets/img/snake-img.png'
import treeImg from '../assets/img/tree-img.png';
import crystalStar from '../assets/img/crystal-star-img.png'
import infStar from '../assets/img/infl-star-img.png'

export const InviteCard = () => {
    const invCards = [
        {id: 1, title: 'Пригласите 1 друга и получите 20$', lottery: '100 000 USDT', url: snakeImg},
        {id: 2, title: 'Пригласите 1 друга и получите 20$', lottery: '100 000 USDT', url: treeImg},
        {id: 3, title: 'Пригласите 1 друга и получите 20$', lottery: '100 000 USDT', url: crystalStar},
        {id: 4, title: 'Пригласите 1 друга и получите 20$', lottery: '100 000 USDT', url: infStar},
    ]
  return (
    <>
        <div id="invite-card">
            <div className="container">
                <div className="invite-card">
                    <div className="inv-cards">
                        {
                            invCards.map(card => (
                                <div className="inv-card" key={card.id}>
                                    <div className="inv-card-txt">
                                        <span className="inv-card-bonus">Бонусы для новых пользователей</span>
                                        <div className="inv-card-title">{card.title}</div>
                                        <div className="inv-card-lottery">Розыгрыш <span>{card.lottery}</span></div>
                                    </div>
                                    <div className="inv-card-img">
                                        <img src={card.url} alt="" />
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}
